import {
  reset as resetCore, signIn, testingDashboardSignIn, updateRefreshToken,
} from '../reducers/core-reducer';
import { reset as resetAccount } from '../reducers/account-reducer';
import { reset as resetUserInput } from '../reducers/user-input-reducer';
import { reset as resetBill } from '../reducers/bill-reducer';
import { reset as resetVisualizer } from '../reducers/visualizer-reducer';
import { store } from '../store';
import { LoginResponse, TestingDashboardLoginResponse } from '../models';
import { AuthService } from './auth-service';

class SessionService {
  public static signIn(loginResp: LoginResponse) {
    // eslint-disable-next-line max-len
    [signIn({ token: loginResp.authToken }), updateRefreshToken({ refreshToken: loginResp.refreshToken })].forEach((x) => store.dispatch(x));
    AuthService.setAuthToken(loginResp.authToken);
    AuthService.setRefreshToken(loginResp.refreshToken);
  }

  public static testingDashboardSignIn(loginResp: TestingDashboardLoginResponse) {
    [testingDashboardSignIn({ token: loginResp.authToken })].forEach((x) => store.dispatch(x));
    AuthService.setTestingDashboardAuthToken(loginResp.authToken);
  }

  public static signOut() {
    AuthService.setAuthToken('');
    AuthService.setRefreshToken('');
    AuthService.setTestingDashboardAuthToken('');
    [resetAccount(''), resetBill(''), resetVisualizer(''), resetCore(''), resetUserInput('')].forEach((x) => store.dispatch(x));
  }
}

export { SessionService };
